import React from 'react'

import Avatar from '../../atoms/Avatar'
import Font from '../../atoms/Font'

import style from './style.css'
import Button from '../../atoms/Button';

export default props =>

<div className={style.boxUser}>
   <div className={style.avatar}>
      <a href={props.user.href}>
         <Avatar size='100' img={props.user.avatar} />
      </a>
   </div>
   {props.showBtn && (
      <div className={style.button}>
         <Button
            theme={props.following ? 'secondary' : 'primary'}
            styled='tag'
            style={{width: '123px'}}
            onClick={() => { props.action() }}> {props.label} </Button>
      </div>
   )}
   <a href={props.user.href}>
      <div className={style.username}>
            <Font color='#666'>{props.user.name}</Font>
      </div>
   </a>
</div>


// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/FollowUser/index.js